import { AxiosResponse } from 'axios';

import { Brand } from '../pages/inventory-control/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessGetBrand extends ResponseREST {
	data: Array<Brand>;
}

export const getBrands = async (): Promise<ResponseSuccessGetBrand> => {
	return axiosInstance
		.get('get-list-brand')
		.then((res: AxiosResponse<ResponseSuccessGetBrand>) => res.data)
		.catch((err) => err);
};
